<template>
    <div class="dashboard">
        <h1>月別車両点検変更</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w7 l-2-20-t--all">
                <div>
                    <h2>対象月</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="params.month" type="month" :disabled="flagDisabled">
                    </div>
                    <h2>車両ID</h2>
                    <div class="l-mt2 l-mb10">
                        <input v-model="params.id" type="number" :disabled="flagDisabled">
                    </div>
                    <div>
                        <input id="amount_of_cooling_water" v-model="input.amount_of_cooling_water" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="amount_of_cooling_water">冷却水の量</label>
                    </div>
                    <div class="l-mt2">
                        <input id="fan_belt_tension" v-model="input.fan_belt_tension" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="fan_belt_tension">ファン・ベルトの張り具合、損傷</label>
                    </div>
                    <div class="l-mt2">
                        <input id="engine_oil_quantity" v-model="input.engine_oil_quantity" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="engine_oil_quantity">エンジン・オイルの量</label>
                    </div>
                    <div class="l-mt2">
                        <input id="battery_fluid_level" v-model="input.battery_fluid_level" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="battery_fluid_level">バッテリー液の量</label>
                    </div>
                    <div class="l-mt2">
                        <input id="tire_groove_depth" v-model="input.tire_groove_depth" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="tire_groove_depth">タイヤの溝の深さ</label>
                    </div>
                    <div class="l-mt2">
                        <input id="washer_fluid_volume_and_injection_status" v-model="input.washer_fluid_volume_and_injection_status" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="washer_fluid_volume_and_injection_status">ウォッシャー液量及び噴射状態</label>
                    </div>
                    <div class="l-mt2 l-mb10">
                        <input id="wiper_wipe_state" v-model="input.wiper_wipe_state" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="wiper_wipe_state">ワイパーの払拭状態</label>
                    </div>
                </div>
                <div>
                    &nbsp;
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen('updateVehicleInspectionsMonth')">次へ</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "required": true,
                "type": String,
            },
            "month": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "flagDisabled": true,
                "input": {
                    "inspection_month": this.month,
                    "amount_of_cooling_water": "0",
                    "fan_belt_tension": "0",
                    "engine_oil_quantity": "0",
                    "battery_fluid_level": "0",
                    "tire_groove_depth": "0",
                    "washer_fluid_volume_and_injection_status": "0",
                    "wiper_wipe_state": "0",
                },
                "inputType": "checkbox",
                "params": {
                    "id": this.id,
                    "month": this.month,
                },
                "valueFalse": "0",
                "valueTrue": "1",
            };
        },
        created() {
            this.fetchingListVehicleInspections(this.id);
        },
        "methods": {
            modalAction(key) {
                if (key === "updateVehicleInspectionsMonth") {
                    this.handleUpdate();
                } else if (key === "updateVehicleInspectionsMonth--finished") {
                    this.$router.push({ "name": "offices_vehicle_inspections_list" });
                }
            },
            fetchingListVehicleInspections() {
                // 車両点検詳細データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicle_inspection_detail`,
                    this.$_requestConfig("params")
                ).then(response => {
                    const dateArray = response.data.month;
                    const inspection = dateArray.map((item) => {
                        if (item.inspection_date.indexOf(this.month) !== -1) {
                            return item;
                        }
                    }).filter(Boolean)[0];
                    if (inspection) {
                        this.input = {...this.input, ...inspection};
                    }
                }).catch(() => {
                    this.$_modalError("fetchingVehicleInspectionsError");
                });
            },
            handleUpdate() {
                // 月別車両点検データ更新
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicle_inspection_months/${this.params.id}/update`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
